module.exports = __webpack_public_path__ + "img/data-nodes2.44475ce5.png";